import { saveChanged } from '../../lib/save';

/*
  SENDING A SHEET IN, and saying truthfully whether it went, 18 September 2026.

  Moved out of CountEntry.jsx in the audit after the rebrand (issue 11), so a
  test can hand it each answer the server can give. Whenever the server said
  no, the sheet used to be marked submitted directly without looking at the
  answer, and the rep was told "Count submitted." with the audit row and the
  approval task written anyway, so a sheet the database had refused (a blank
  line, not theirs) was reported sent in.

  - **The server saying no** (not signed in, not yours, no such sheet: a 4xx)
    is shown as it is, and the rep stays on the sheet.
  - **Anything else** (no signal, or a fault part-way, which can come AFTER the
    sheet was marked submitted, when the email fails) asks the database whether
    the sheet is submitted, marks it so if it is not, and reports success only
    when it really is.

  Answers 'submitted', 'refused' or 'failed'. Only 'submitted' may go on to the
  audit row, the approval task and leaving the sheet.
*/
export async function sendSheetIn({ supabase, toast, countId, callServer }) {
  let refusedWith = null;
  try {
    const res = await callServer();
    if (res.ok) {
      toast.success('Count submitted. A summary is on its way to you and the inventory team.', { mark: 'delivered' });
      return 'submitted';
    }
    const err = await res.json().catch(() => ({}));
    if (res.status >= 400 && res.status < 500) refusedWith = err.error || 'The count was refused.';
    else throw new Error(err.error || 'Submission failed');
  } catch (e) {
    console.error('Submit error:', e);
  }
  if (refusedWith) {
    toast.error('Not submitted: ' + refusedWith);
    return 'refused';
  }
  const { data: now } = await supabase.from('inventory_counts').select('status').eq('id', countId).maybeSingle();
  if (now?.status !== 'submitted') {
    const ok = await saveChanged(toast, () => supabase.from('inventory_counts')
      .update({ status: 'submitted', submitted_at: new Date().toISOString() })
      .eq('id', countId).select('id'), 'the count as submitted');
    if (!ok) return 'failed';
  }
  toast.success('Count submitted, but its summary email may not have been sent.', { mark: 'delivered' });
  return 'submitted';
}
